import type { PrefillMode } from "@/stores/composerDraftStore";

/**
 * Merge an incoming composer prefill into the composer's current (live) text.
 *
 * The inject effect runs this against the live value:
 * `setMessage(prev => applyPrefill(prev, incoming, mode))`.
 *
 * - `replace` swaps the composer to `incoming` (Retry / Remix / Upscale / Animate).
 * - `append` extends the live text with a single separating space so a typed note
 *   or an already-injected prefill survives (Studio's "Set as ref"). Appending
 *   onto empty or whitespace-only text is just `incoming` (no leading space).
 */
export function applyPrefill(
  current: string,
  incoming: string,
  mode: PrefillMode
): string {
  if (mode === "append" && current.trim()) {
    return `${current.trimEnd()} ${incoming}`;
  }
  return incoming;
}
